import { styled } from "@mui/material/styles";

import { Avatar, Box, Typography, alpha, Chip, IconButton, Link } from "@mui/material";
import theme, { palette, shadows } from "src/config/theme";
import InputComponent from "src/components/shared/Form/Input";
import ButtonComponent from "src/components/shared/Button";
import InputSelect from "src/components/shared/Form/Select";
import { Link as RouterLink } from 'react-router-dom';

export const LoginContainer = styled(Box)({
    width: '300px',
    height: 'auto',
    borderRadius: '12px',
    border: `1px solid ${theme.palette.primary.light1}`,
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.gery.white,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    [theme.breakpoints.between(500, 700)]: {
        width: '300px'
    },
    [theme.breakpoints.down(500)]: {
        width: '250px'
    }
    // gap: '8px'
})

export const LoginTextContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    marginTop: 0,
});

export const LoginText = styled(Typography)({
    borderBottom: `1px solid ${palette.gery.black}`,
    borderWidth: '2px',
    color: palette.gery.black,
    ...theme.typography.h2,
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.h2
    }
})

export const InputTextComponent = styled(InputComponent)({
    backgroundColor: theme.palette.gery.white,
    boxShadow: theme.shadows[1],
    '& .MuiOutlinedInput-root': {
        // padding: '10px 18px',
        borderRadius: '12px',
        height: '52px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
    },

    "& .MuiInputBase-input.MuiOutlinedInput-input": {
        ...theme.typography.h5,
        [theme.breakpoints.down('md')]: {
            ...theme.mobileTypography.body2
        }
    },
})
export const SaveButton = styled(ButtonComponent, {
    shouldForwardProp: (prop) => prop !== 'fullWidth',
})(({ fullWidth }) => ({
    width: fullWidth ? '100%' : '104px',
    height: '52px',
    borderRadius: '12px',
    padding: '10px 18px',
    backgroundColor: palette.primary.main,
    boxShadow: shadows[1],
    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
    color: palette.gery.white,
    '&:hover': { color: palette.primary.main },
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.h6,
        minWidth: fullWidth ? '100%' : '78px',
        height: '40px',
        borderRadius: '8px',
        padding: '10px 12px'
    }
}));

export const Texts = styled(Typography)({
    color: palette.gery.black,
    ...theme.typography.smallRegular,
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.smallRegular
    }
});

export const StepsContainer = styled(Box)({
    width: '600px',
    height: 'auto',
    borderRadius: '12px',
    border: `1px solid ${theme.palette.primary.light1}`,
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.gery.white,
    // padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.between(500, 700)]: {
        width: '420px'
    },
    [theme.breakpoints.down(500)]: {
        width: '300px'
    }

})
export const AddContainer = styled(Box)(({ isExpanded, theme }) => ({
    backgroundColor: theme.palette.gery.white,
    maxHeight: '400px',
    padding: '0px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    overflowY: 'auto',
    transition: 'height 0.3s ease-in-out',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': {
        display: 'none',
    }
}));
export const Component4 = styled(Box)({
    // width: '430px',
    // height: '144px',
    display: 'flex',
    gap: '4px',
    flexDirection: 'column'

});

export const TwoButton = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    // marginTop: '30px',


})
export const InnerTwoButtons = styled(Box)({
    display: 'flex',
    gap: '10px'
})

export const HeaderPart = styled(Box)({
    // height: "100px",
    padding: ' 10px 20px',
    // display: 'flex',
    // flexDirection: 'column',
    // // justifyContent: 'space-between',
    // alignItems: 'center',
    // gap: '16px',
    borderBottom: `1px solid ${theme.palette.primary.light1} !important`,
    [theme.breakpoints.down('md')]: {

        // height: '60px !important',
        padding: '10px 16px'
    }
})

export const FooterPart = styled(Box)({
    height: "80px",
    padding: ' 10px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    borderTop: `1px solid ${theme.palette.primary.light1} !important`,
    [theme.breakpoints.down('md')]: {

        height: '60px !important',
        padding: '10px 16px'
    }
})
export const Component6 = styled(Box)({
    display: 'flex',
    gap: '4px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
})

export const PrescriptionViewBox = styled(Box)({
    display: 'flex',
    // flexDirection: 'row',
    backgroundColor: palette.primary.light5,
    boxShadow: shadows[1],
    justifyContent: 'space-between',
    padding: '10px',
    borderRadius: '12px',
    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,


})

export const PresTitle = styled(Typography)({
    color: palette.gery.black,
    ...theme.typography.h5,
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.body2
    }

})
export const PresText = styled(Typography)({
    color: palette.gery.black,
    ...theme.typography.smallRegular,
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.smallRegular
    }
})
export const EditButton = styled(Avatar)({
    backgroundColor: palette.primary.light3,
    boxShadow: shadows[1],
    color: palette.primary.main,
    width: '35px',
    height: '35px',
    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
    cursor: 'pointer',
    [theme.breakpoints.down('md')]: {
        width: '28px',
        height: '28px',
    }
})
export const InnerComponent = styled(Box)({
    display: 'flex',
    gap: '4px',
    flexDirection: 'column',
    height: '76px',
    width: '250px',
    [theme.breakpoints.down(500)]: {
        width: 'auto'
    }
})
export const Component2 = styled(Box)({
    height: '76px',
    display: 'flex',
    gap: '22px',
    justifyContent: 'space-between',
    [theme.breakpoints.down(500)]: {
        flexDirection: 'column',
        height: 'auto',
        border: `1px solid ${palette.primary.light1}`,
        padding: '10px 15px',
        borderRadius: '12px',
        gap: '10px'

    }
    // width: '420px'
});

export const StepText = styled(Typography)({
    color: theme.palette.gery.black,
    ...theme.typography.h3,
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.h3

    }
})



export const ThankYouContainer = styled(Box)({
    width: '400px',
    height: 'auto',
    borderRadius: '12px',
    border: `1px solid ${theme.palette.primary.light1}`,
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.gery.white,
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flexDirection: 'column',
    [theme.breakpoints.between(500, 700)]: {
        width: '300px'
    },
    [theme.breakpoints.down(500)]: {
        width: '250px'
    }
    // gap: '8px'
})
export const ThankYouText = styled(Typography)({
    color: palette.primary.main,
    ...theme.typography.h3,
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.h5
    }
})
export const Text = styled(Typography)({
    color: palette.gery.black,
    ...theme.typography.small,
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.small
    }
})

export const ImgContainer = styled(Avatar)({
    width: '50px',
    height: '50px',
    border: `2px solid ${palette.primary.main}`,
    padding: '10px'
})
export const LinkTitle = styled(RouterLink)({
    color: palette.primary.main,
    ...theme.typography.small,
    [theme.breakpoints.down('md')]: {
        ...theme.mobileTypography.small
    }
})

export const RemoveButton = styled(Avatar)({
    backgroundColor: palette.primary.light3,
    boxShadow: shadows[1],
    color: palette.primary.main,
    width: '35px',
    height: '35px',
    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
    cursor: 'pointer',
    [theme.breakpoints.down(500)]: {
        width: '22px',
        height: '22px',
        position: 'absolute',
        top: 0
    }
})
